import React from 'react';
import { UserPlus, UserCheck, UserX, CheckCircle, XCircle, AlertCircle, Clock, Star, DollarSign } from 'lucide-react';

const activityIcons = {
  user_registered: UserPlus,
  user_approved: UserCheck,
  user_deleted: UserX,
  request_approved: CheckCircle,
  request_rejected: XCircle,
  request_created: AlertCircle,
  worker_deactivated: UserX,
  worker_reactivated: UserCheck,
  payment_received: DollarSign,
  review_submitted: Star,
  dispute_opened: AlertCircle,
  dispute_resolved: CheckCircle,
  default: Clock,
};

const activityColors = {
  user_registered: 'bg-blue-500/20 text-blue-400',
  user_approved: 'bg-green-500/20 text-green-400',
  user_deleted: 'bg-red-500/20 text-red-400',
  request_approved: 'bg-green-500/20 text-green-400',
  request_rejected: 'bg-red-500/20 text-red-400',
  request_created: 'bg-yellow-500/20 text-yellow-400',
  worker_deactivated: 'bg-red-500/20 text-red-400',
  worker_reactivated: 'bg-green-500/20 text-green-400',
  payment_received: 'bg-green-500/20 text-green-400',
  review_submitted: 'bg-purple-500/20 text-purple-400',
  dispute_opened: 'bg-red-500/20 text-red-400',
  dispute_resolved: 'bg-green-500/20 text-green-400',
  default: 'bg-gray-500/20 text-gray-400',
};

const ActivityFeed = ({ activities = [] }) => {
  const formatTime = (timestamp) => {
    const date = new Date(timestamp);
    const now = new Date();
    const diff = Math.floor((now - date) / 1000);

    if (diff < 60) return 'Agora';
    if (diff < 3600) return `há ${Math.floor(diff / 60)} min`;
    if (diff < 86400) return `há ${Math.floor(diff / 3600)} h`;
    if (diff < 604800) return `há ${Math.floor(diff / 86400)} d`;
    return date.toLocaleDateString('pt-BR');
  };

  return (
    <div className="bg-gray-800 rounded-xl border border-gray-700 overflow-hidden">
      <div className="p-4 border-b border-gray-700">
        <h3 className="text-lg font-semibold text-white">Atividade Recente</h3>
      </div>
      <div className="max-h-[400px] overflow-y-auto">
        {activities.length === 0 ? (
          <div className="p-8 text-center text-gray-500">
            <Clock className="w-8 h-8 mx-auto mb-2 opacity-50" />
            <p>Sem atividade recente</p>
          </div>
        ) : (
          <div className="divide-y divide-gray-700">
            {activities.map((activity, idx) => {
              const Icon = activityIcons[activity.type] || activityIcons.default;
              const colorClass = activityColors[activity.type] || activityColors.default;

              return (
                <div key={idx} className="p-4 hover:bg-gray-700/50 transition-colors flex items-start gap-3">
                  <div className={`p-2 rounded-lg ${colorClass} flex-shrink-0`}>
                    <Icon className="w-4 h-4" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="text-sm text-gray-200">{activity.message}</p>
                    <p className="text-xs text-gray-500 mt-1">{formatTime(activity.timestamp)}</p>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default ActivityFeed;
